import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from '../shared/storage.service';
import { AuthService } from '../auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from '../../interfaces/interface-bakend/response';
import { GuiMsjService } from '../shared/gui-msj.service';
import { Router } from '@angular/router';
import { Perfil } from '@interfaces/interface-bakend/seguridad/acl/perfil.interface';

const URL_BACKEND = environment.urlBackend;
@Injectable({
  providedIn: 'root'
})
export class PerfilesService {

  perfilSeleccionado: Perfil | null = null;

  constructor(
      private authService: AuthService,
      private httpClient: HttpClient,
      private guiMsjService: GuiMsjService,
      private router: Router,
  ) { }


  async allowedByUserLogon(redirectTo: string, previousRoute?: string, perfil?: string): Promise<boolean>{
    return new Promise( async resolve => {
        const headers =  new HttpHeaders({
            'x-token': await this.authService.loadJwToken(),
        });

        const data = {
            redirectTo,
            tipoMenu: 'menuWeb'
        };

        this.httpClient.post<Response>(`${ URL_BACKEND }/perfiles/allowedByUserLogon/`,  data , { headers })
            .subscribe( resp => {
                // console.log('usuario con permisos para url', resp.response);
                if (!resp.response) {
                    this.router.navigateByUrl(previousRoute).then(() => {
                        this.guiMsjService.msjFormSubmit('SinPermisoParaUrl', perfil);
                    });
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        });
  }

  async createPerfil(data: any): Promise<any> {
    return new Promise(async (resolve) => {
      const headers = new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
      });
      this.httpClient
        .post(`${URL_BACKEND}/perfiles`, data, { headers })
        .subscribe(
          (resp) => resolve(resp),
          (error) => { console.error('[Perfiles][POST] Error:', error); resolve(null); },
        );
    });
  }

  async updatePerfil(id: string, data: any): Promise<any> {
    return new Promise(async (resolve) => {
      const headers = new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
      });
      this.httpClient
        .put(`${URL_BACKEND}/perfiles/updateOne/${id}`, data, { headers })
        .subscribe(
          (resp) => resolve(resp),
          (error) => { console.error('[Perfiles][PUT] Error:', error); resolve(null); },
        );
    });
  }

  async deletePerfil(id: string): Promise<any> {
    return new Promise(async (resolve) => {
      const headers = new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
      });
      this.httpClient
        .delete(`${URL_BACKEND}/perfiles/${id}`, { headers })
        .subscribe(
          (resp) => resolve(resp),
          (error) => { console.error('[Perfiles][DELETE] Error:', error); resolve(null); },
        );
    });
  }

  async findPerfilById(id: string): Promise<any> {
    return new Promise(async (resolve) => {
      const headers = new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
      });
      this.httpClient
        .get<any>(`${URL_BACKEND}/perfiles/findOne/${id}`, { headers })
        .subscribe(
          (resp) => {
            console.log('[Perfiles][GET] findOne respuesta cruda:', resp);
            resolve(resp);
          },
          (error) => { console.error('[Perfiles][GET] Error:', error); resolve(null); },
        );
    });
  }

  async findAllPerfiles(): Promise<any> {
    return new Promise(async (resolve) => {
      const headers = new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
      });
      this.httpClient
        .get<any>(`${URL_BACKEND}/perfiles/findAll`, { headers })
        .subscribe(
          (resp) => {
            console.log('[Perfiles][GET] findAll respuesta cruda:', resp);
            resolve(resp);
          },
          (error) => { console.error('[Perfiles][GET] Error:', error); resolve(null); },
        );
    });
  }

  setPerfilSeleccionado(perfil: Perfil | null): void {
    this.perfilSeleccionado = perfil;
  }

  getPerfilSeleccionado(): Perfil | null {
    return this.perfilSeleccionado;
  }
}
